// Components
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";

// Types
import { IPeriodTreeSelection } from "@/Layouts/components/SideBars/PayPeriodSideBar/interfaces";

// Images
import emptyTable from "@/assets/images/commons/empty_table.png";
import empty from "@/assets/images/commons/empty.png";

interface IRenderEmptyBodyProps {
	selected: IPeriodTreeSelection;
}
const TimeAndPayRatesEmptyBody = (props: IRenderEmptyBodyProps) => {
	const { selected } = props;
	return (
		<EmptyBody
			image={selected ? emptyTable : empty}
			imageStyles={{ width: "320px" }}
			title={selected ? "No Time & Pay Rates found for this month" : "Select a pay period to view the Time & Pay Rates"}
			bodyHeight={"300px"}
			sx={{
				boxShadow: "none !important",
			}}
		/>
	);
};

export default TimeAndPayRatesEmptyBody;
